'use client';

import { ArrowDown, Plus } from 'lucide-react';

import { memo } from 'react';

import { useRouter } from '@shared/hooks/use-router';
import { Button } from '@/components/ui/button';

import { STATIC_FORM_ID } from '@/features/form-editing/components/constants/form-edit-constants';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { APP_ROUTES } from '@/shared/constants/navigation';
import { useAppCallbacks, useAppStore } from '@/shared/contexts/app-wrapper/providers/app-provider';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';
import { redirectViaWindow } from '@/shared/utils/window';

import { getFormEditPath } from '@/utils/common';

interface Props {}

function CreateFormBtn({}: Props) {
	const router = useRouter();
	const isApplicantMode = useAppStore((state) => state.isApplicantMode);
	const { handleShowWorkspaceSelector, refetchUserDetails } = useAppCallbacks((state) => state);

	const handleImportForm = () => {
		emitMixpanelEvent(mixpanelEvents.IMPORT_BUTTON_CLICKED, {
			feature: MIXPANEL_APP_FEATURES.DASHBOARD,
		});

		if (isApplicantMode) {
			handleShowWorkspaceSelector({
				showSelectWorkspace: true,
				callback: () => {
					redirectViaWindow(APP_ROUTES.ROOT);
				},
			});
			return;
		}

		router.push(APP_ROUTES.IMPORT_FORM);
	};

	const handleCreateDraftForm = async () => {
		emitMixpanelEvent(mixpanelEvents.CLICKED_DASHBOARD_NEW_FORM, {
			feature: MIXPANEL_APP_FEATURES.DASHBOARD,
		});

		router.push(getFormEditPath(STATIC_FORM_ID));
	};

	return (
		<div className="flex items-center gap-2">
			<Button
				variant={'outline'}
				size={'sm'}
				onClick={handleImportForm}
				className="gap-0"
			>
				<ArrowDown className="size-4" />
				<span className="ml-1">Import</span>
			</Button>

			<Button
				variant={'blue'}
				size={'sm'}
				onClick={() =>
					isApplicantMode
						? handleShowWorkspaceSelector({
								showSelectWorkspace: true,
								callback: () => refetchUserDetails(),
							})
						: handleCreateDraftForm()
				}
				className="group gap-0 transition-all"
			>
				<Plus size={16} />
				<span className="ml-1">New Form</span>
			</Button>
		</div>
	);
}

export default memo(CreateFormBtn);
